import { useState, useEffect } from 'react';
import styled from 'styled-components';
import logoutIcon from '../img/logout.png';

import { useNavigate, useLocation } from 'react-router-dom';
import { useRef } from 'react';
import axios from 'axios';
import qs from 'qs';

const Header = () => {
	const [Login, setLogin] = useState(false);
	const [IsProc, setIsProc] = useState(false);
	const [IsProcPage, setIsProcPage] = useState(false);
	const [PreviousPath, setPreviousPath] = useState('');
	const [ExpiryTime, setExpiryTime] = useState(0); // 남은 시간 (단위: 초)
	const [TimeText, setTimeText] = useState(''); // 남은 시간 (단위: 초)

	const navigate = useNavigate();
	const location = useLocation();
	const goPage = (path) => {
		navigate(path);
	};

	const clickLogout = () => {
		//로그아웃 버튼으로 인한 로그아웃
		/* eslint-disable no-restricted-globals */
		const isOk = confirm('로그아웃 하시겠습니까?');
		/* eslint-enable no-restricted-globals */
		if (isOk) {
			if (timerRef.current) {
				clearTimeout(timerRef.current);
			}
			localStorage.clear();
			setLogin(false);
			alert('로그인 페이지로 이동합니다.');
			navigate('/login');
			sessionStorage.removeItem('previousPath');
			setTimeText('');
		}
	};
	const handleProc = () => {
		if (location.pathname !== '/proc') return navigate('/proc');
		if (location.pathname === '/proc' && PreviousPath !== '/proc') {
			return navigate(-1);
		}
		//TODO :: 로그인 페이지로 다시 돌아가지 않게 설정
		// if (PreviousPath === '/' && location.pathname !== '/') return navigate('/');
		// if (PreviousPath === '/' && location.pathname === '/proc') return navigate('/');
	};
	const timerRef = useRef(null);
	useEffect(() => {
		let timer = null;
		timerRef.current = null;

		if (localStorage.length > 0 && localStorage.getItem('token')) {
			let newExpiry = localStorage.expiry;
			setLogin(true);

			if (newExpiry) {
				timer = setTimeout(() => {
					handleLogout();
					sessionStorage.removeItem('previousPath');
				}, newExpiry);

				timerRef.current = timer;
				setExpiryTime(newExpiry * 0.001);

				const textTimer = setInterval(() => {
					setExpiryTime((prev) => prev - 1);
				}, 1000);
				return () => {
					clearInterval(textTimer);
					setTimeText('');
				};
			}
		} else {
			timerRef.current && clearTimeout(timerRef.current);
			setLogin(false);
		}
	}, [localStorage.length]);
	useEffect(() => {
		let newExpiry = ExpiryTime;
		changeTimer(Number(newExpiry));
	}, [ExpiryTime]);
	const changeTimer = (seconds) => {
		let newSeconds = seconds;
		if (newSeconds < 61) {
			return setTimeText('00:' + addZero(newSeconds));
		}

		var hours = Math.floor(newSeconds / 3600);
		var mins = Math.floor((newSeconds - hours * 3600) / 60);
		var secs = newSeconds - hours * 3600 - mins * 60;
		return setTimeText(
			addZero(hours) + ':' + addZero(mins) + ':' + addZero(secs)
		);

		function addZero(num) {
			return (num < 10 ? '0' : '') + num;
		}
	};
	const handleLogout = () => {
		//토큰만료로 인한 로그아웃
		if (timerRef.current) {
			clearTimeout(timerRef.current);
		}
		localStorage.clear();
		setLogin(false);
		setTimeout(() => {
			alert('토큰이 만료되어 로그인페이지로 이동합니다.');
			navigate('/login');
		}, 100);
	};
	useEffect(() => {
		// if (window.location.pathname === '/proc' && PreviousPath !== '/') {
		// 	sessionStorage.setItem('previousPath', '/proc');
		// 	setPreviousPath('/proc');
		// }
		if (window.location.pathname === '/') setPreviousPath('/');
		//TODO :: 세선스토지에 담기는거 부터 보기
		// 세션 스토리지에 이전 경로 저장
		//TODO::home에서 proc들어갔을 때 x누르면 이전페이지로

		if (location.pathname === '/proc') {
			setIsProcPage(true);
		} else {
			setIsProcPage(false);
		}
		if (
			location.pathname === '/proc' ||
			location.pathname === '/hub' ||
			location.pathname === '/order' ||
			location.pathname === '/market'
		) {
			setIsProc(true);
		} else {
			setIsProc(false);
		}
	}, [location.pathname]);
	// 페이지 렌더링 후 가장 처음 호출되는 함수
	useEffect(
		() => {
			if (!localStorage.getItem('token')) goPage('/');
			else {
				axios
					.post(
						`${window.location.protocol}//${window.location.hostname}:3001/check`,
						qs.stringify({
							token: localStorage.getItem('token'),
						})
					)
					.then((res) => {
						if (res.data.expired) {
							localStorage.removeItem('token');
							goPage('/login');
							sessionStorage.setItem('previousPath', '/');
							setPreviousPath('/');
						}
					})
					.catch();
			}
		},
		// 페이지 호출 후 처음 한번만 호출될 수 있도록 [] 추가
		[]
	);

	return (
		<Container IsProc={IsProc} className={IsProc ? 'IsProc' : ''}>
			<Wrapper>
				<Left>
					<Navigations>
						<Navs
							onClick={() => {
								navigate('/');
							}}
						>
							Home
						</Navs>
						<Navs>About Aios</Navs>
						<Navs>Company</Navs>
						<Navs>Help</Navs>
					</Navigations>
				</Left>
				<Right>
					<RightWrapper>
						<Navs
							style={{
								marginLeft: '0px',
							}}
							onClick={() => {
								navigate('/login');
							}}
							hidden={Login}
						>
							Log In
						</Navs>
						<Navs
							style={{
								marginLeft: '0px',
							}}
							onClick={() => handleProc()}
							hidden={!Login}
						>
							<div className={IsProcPage ? 'bars hover' : 'bars'}>
								<span>Proc</span>
								<span>
									<span className='bar'></span>
									<span className='bar'></span>
									<span className='bar'></span>
								</span>
							</div>
						</Navs>
						{Login && (
							<>
								<button
									type='button'
									onClick={() => clickLogout()}
									className='logoutButton'
								>
									<span>로그아웃</span>
									<span>
										<img src={logoutIcon} alt='로그아웃 아이콘' />
									</span>
								</button>
								<span>{TimeText}</span>
							</>
						)}
					</RightWrapper>
				</Right>
			</Wrapper>
		</Container>
	);
};

export default Header;

// const Icon = styled.div`
// 	display: none;
// 	@media screen and (max-width: 850px) {
// 		display: flex;
// 		color: #7b69dd;
// 		font-size: 30px;
// 		align-items: center;
// 		height: 100%;
// 		cursor: pointer;
// 	}
// `;

// const Button = styled.div`
// 	width: 130px;
// 	height: 42px;
// 	display: flex;
// 	align-items: center;
// 	justify-content: center;
// 	border: 2px solid white;
// 	border-radius: 5px;
// 	color: white;
// 	cursor: pointer;
// 	font-size: 15px;
// `;
const Container = styled.div`
	width: 100%;
	overflow: hidden;
	position: relative;
	${(props) =>
		props.IsProc
			? 'height: 60px; background-color:#222; color:#eee;'
			: 'height: 100px;background-color:#f8f8fd;'};
	display: flex;
	justify-content: center;
	align-items: center;
	font-family: 'Space Grotesk', sans-serif;
	transition: 0.2s;
	/* z-index: 1; */
`;
const Wrapper = styled.div`
	${(props) => (props.IsProc ? 'width: 90%;' : 'width: 80%;')};

	display: flex;
	/* background-color: green; */
	height: 100%;
	justify-content: space-between;
	align-items: center;
	/* z-index: 1; */
	@media screen and (max-width: 1090px) {
		width: 90%;
	}
`;

const RightWrapper = styled.div`
	/* width: 65%; */
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	@media screen and (max-width: 850px) {
		display: none;
	}
	/* background-color: purple; */
`;

const Navs = styled.div`
	margin: 0 25px;
	font-weight: 500;
	cursor: pointer;
	@media screen and (max-width: 980px) {
		margin: 0 20px;
	}
`;

const Navigations = styled.div`
	display: flex;
	@media screen and (max-width: 850px) {
		display: none;
	}
`;
// const Logo = styled.img`
// 	width: 90px;
// 	height: 35px;
// 	object-fit: contain;
// 	margin-right: 60px;
// 	@media screen and (max-width: 910px) {
// 		margin-right: 40px;
// 	}
// `;

const Right = styled.div`
	width: 35%;
	height: 100%;
	@media screen and (max-width: 1200px) {
		width: auto;
	}
`;

const Left = styled.div`
	display: flex;
	align-items: center;
`;
